import Http from "@/libs/axios";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {},
  mutations: {},
  actions: {
    getNewTwoFactorInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        Http.get("auth/2fa/new")
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    enableTwoFactor({ commit }, data) {
      return new Promise((resolve, reject) => {
        Http.post("auth/2fa/enable", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    authenticate({ commit }, data) {
      return new Promise((resolve, reject) => {
        Http.post("auth/2fa", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    resetMFA({ commit }, id) {
      return new Promise((resolve, reject) => {
        Http.delete(`auth/2fa/${id}`)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
  },
};
